module.exports = __webpack_public_path__ + "img/th.63587128.png";